import React, { createContext, useRef } from "react";
export const RefDialogContext = createContext(undefined);
export const Provider = ({ children }) => {
    const refs = useRef({});
    const register = (id, ref) => {
        if (refs.current && !(id in refs.current)) {
            refs.current[id] = ref;
        }
    };
    const unregister = (id) => {
        if (refs.current && id in refs.current) {
            refs.current[id] = undefined;
        }
    };
    return (React.createElement(RefDialogContext.Provider, { value: {
            register,
            unregister,
            refs: refs.current
        } }, children));
};
//# sourceMappingURL=Provider.js.map